export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-300">
      <div className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-2.5 cursor-pointer mb-4"
            >
              <div className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">屁屁影院</span>
            </a>
            <p className="text-sm leading-relaxed max-w-md">
              屁屁影院是国内领先的免费影视在线观看平台，汇聚电影大全超12万部，高清免费在线观看不缓冲。最新高清大片全集即点即播，热门经典一网打尽，秒播免费影视网站大全，为每一位影迷打造极致的观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#media" onClick={(e) => { e.preventDefault(); document.getElementById('media')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">精彩推荐</a>
              <a href="#topics" onClick={(e) => { e.preventDefault(); document.getElementById('topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#ranking" onClick={(e) => { e.preventDefault(); document.getElementById('ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">热播排行</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2020-2026 屁屁影院 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}